// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"bf48dd14fc4a6fe977381000b8ff664afd664c40"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { FullStory, init } from "@fullstory/browser";
import { fullStoryIntegration } from "@sentry/fullstory";
import * as Sentry from "@sentry/nextjs";
import { DEPLOY_STAGE, FULLSTORY_ORG_ID, SENTRY_ORG_SLUG } from "./src/config";

const deployStages: string[] = ["local", "staging", "prod"];

if (FULLSTORY_ORG_ID) {
  init({ orgId: FULLSTORY_ORG_ID });
}

const sentryIntegrations = [
  fullStoryIntegration(SENTRY_ORG_SLUG, { client: FullStory }),
  Sentry.httpClientIntegration({
    failedRequestStatusCodes: [500],
  }),
];

if (DEPLOY_STAGE === "prod" || DEPLOY_STAGE === "staging") {
  sentryIntegrations.push(
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    })
  );
}

if (SENTRY_ORG_SLUG && deployStages.includes(DEPLOY_STAGE)) {
  // Only initialize Sentry when DEPLOY_STAGE is set
  Sentry.init({
    dsn: "https://11de0cfc0baac913d36fd3333b437f8a@o4507572568850432.ingest.us.sentry.io/4507584110854144",

    environment: DEPLOY_STAGE,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: sentryIntegrations,
    sendDefaultPii: true,
  });
}
